import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  email: string;
  role: UserRoles;
}

const postLoginMutation = async (values: Payload) => {
  const response = await axios.post('/auth/login', values);
  return response;
};

export const usePostLoginMutation = () => {
  return useMutation({
    mutationKey: ['login'],
    mutationFn: postLoginMutation,
  });
};
